import React from 'react';
import { Page } from 'components';
import { OrdersProvider } from './OrdersContext';
import Orders from './Orders';


let Index = () => {
    return (
        <OrdersProvider>
            <Page title="Orders">
                <Orders />
            </Page>
        </OrdersProvider>
    );
}

export default Index;